export function isEmpty(value: any) {
    if (value === null) return true;
    if (value === undefined) return true;
    if (value === "") return true;
    if (!value.toString().length) return true;
    return false;
}